import { useNavigation } from '~components/navigation-and-footer/navigation/navigation-context'

export const OPEN_DRAWER_WIDTH = 312

export const MOBILE_NAVIGATION_HEIGHT = 64
export function useNavAndFooterConstants() {
  const { isOpen } = useNavigation()

  const lgLeftNavigationWidth = isOpen ? `${OPEN_DRAWER_WIDTH}px` : '90px'
  const topNavigationHeight = { xs: `${MOBILE_NAVIGATION_HEIGHT}px`, lg: '0px' }

  return {
    footerHeight: { xs: '34px', lg: '85px' },
    topNavigationHeight,
    leftNavigationWidth: {
      xs: '0px',
      lg: lgLeftNavigationWidth,
    },
  }
}
